import Link from 'next/link';
import React from 'react';
import { IconType } from 'react-icons';
import { AiFillPicture } from 'react-icons/ai';
import { BsFillPersonCheckFill } from 'react-icons/bs';
import { FaHome, FaRegCheckCircle } from 'react-icons/fa';
import {
    FaUserDoctor,
    FaPhoneVolume,
    FaHeartCircleCheck,
    FaChartGantt,
} from 'react-icons/fa6';
import { HiOutlineMail, HiOutlineOfficeBuilding } from 'react-icons/hi';
import { ImLab } from 'react-icons/im';
import { IoLocationSharp } from 'react-icons/io5';
import { LiaHospitalSolid } from 'react-icons/lia';
import { LuHeartHandshake } from 'react-icons/lu';
import {
    // MdOutlineContactPhone,
    // MdAddBox,
    MdContactPhone,
    MdPersonAddAlt1,
    MdPersonSearch,
} from 'react-icons/md';
import { PiUserCircleCheckLight } from 'react-icons/pi';
import {
    RiInformation2Line,
    RiCustomerService2Line,
    RiFileExcel2Line,
} from 'react-icons/ri';
import {
    SlPeople,
    SlEvent,
    SlList,
    SlOrganization,
    SlUserFollowing,
    SlEqualizer,
    SlCalender,
} from 'react-icons/sl';
import {
    TbHomePlus,
    TbPhoneCalling,
    TbMessage,
    TbBrandDaysCounter,
    TbHeartRateMonitor,
} from 'react-icons/tb';

export const navlinkData = [
    // { id: 1, label: 'خانه', link: '/' },
    { id: 2, label: 'نوبت پزشک', link: '/doctors' },
    { id: 3, label: 'مراکز درمانی', link: '/center' },
    { id: 4, label: 'نوبت آزمایشگاه', link: '/centers/type/lab' },
    { id: 5, label: 'نوبت تصویربرداری', link: '/centers/type/imagingCenter' },
    // { id: 6, label: 'تماس با ما', link: '/contactus' },
    { id: 7, label: 'درخواست همکاری', link: '/join_request' },
];

export const navlinkMobileData = [
    { id: 1, label: 'خانه', link: '/', icon: TbHomePlus },
    { id: 2, label: 'نوبت پزشک', link: '/doctors', icon: FaUserDoctor },
    { id: 4, label: 'مراکز درمانی', link: '/center' },
    { id: 3, label: 'نوبت آزمایشگاه', link: '/centers/type/lab', icon: ImLab },

    {
        id: 5,
        label: 'نوبت تصویربرداری',
        link: '/centers/type/imagingCenter',
        icon: AiFillPicture,
    },
    // {
    //     id: 6,
    //     label: 'تماس با ما',
    //     link: '/contactus',
    //     icon: MdOutlineContactPhone,
    // },
    {
        id: 7,
        label: 'درخواست همکاری',
        link: '/join_request',
        icon: LuHeartHandshake,
    },
    { id: 6, label: 'درباره ما', link: '/aboutus', icon: RiInformation2Line },
];

export const asideFooterData = [
    { id: 1, title: 'تسهیل در روند درمان' },
    { id: 2, title: 'جلوگیری از اتلاف وقت' },
    { id: 3, title: 'جلوگیری از اتلاف منابع مادی و معنوی' },
    { id: 4, title: 'دسترسی سریع تر به پزشکان متخصص' },
    { id: 5, title: 'امکان تشخیص متخصص درون سیستم' },
    { id: 6, title: 'تشکیل پرونده پزشکی اختصاصی' },
    { id: 7, title: '...' },
];

export const footerData = {
    col_1: [
        { id: 1, label: 'نوبت دهی آنلاین پزشکان و مراکز درمانی' },
        {
            id: 3,
            address:
                'شیراز - شهرک آرین - کوچه دو - خیابان فناوری - ساختمان جامع - طبقه دو',
            Icon3: IoLocationSharp,
        },
        { id: 4, phone: '071-91690609', Icon2: MdContactPhone },
        { id: 10, phone2: '09338505757', Icon4: FaPhoneVolume },
        {
            id: 5,
            email: 'info@darmanshirin.com',
            Icon5: HiOutlineMail,
        },
    ],
    col_2: [
        { id: 1, label: 'خانه', link: '/' },
        { id: 2, label: 'درباره ما', link: '/aboutus' },
        { id: 3, label: 'تماس با ما', link: '/contactus' },
        { id: 4, label: 'قوانین', link: '/rules' },
    ],
    col_3: [
        { id: 1, label: 'نوبت پزشک', link: '/doctors' },
        { id: 2, label: 'نوبت آزمایشگاه', link: '/centers/type/lab' },
        { id: 3, label: 'نوبت تصویربرداری', link: '/ImagingCenters' },
    ],
};

// ALL DOCTORS

export const sortRatDoctrosData = [
    { title: 'پیش‌فرض', id: 1 },

    { title: 'محبوب‌ترین', id: 2 },

    { title: 'نزدیک‌ترین نوبت آزاد (نوبت تلفنی)', id: 3 },

    { title: 'بیش‌ترین نوبت موفق', id: 4 },
];

export const servicesAllDcoros = [
    {
        id: 1,
        name: 'نوبت‌دهی مطب',
        Icon: HiOutlineOfficeBuilding,
    },
    {
        id: 2,
        name: 'مشاوره‌ تلفنی',
        Icon: TbPhoneCalling,
    },
    {
        id: 3,
        name: 'مشاوره‌ متنی',
        Icon: TbMessage,
    },
];

// Rules

export const rulesDataModal = (
    name: string,
    per_visit: React.ReactNode | undefined,
    coordination: string,
    useLab_imaging: boolean,
) => {
    const rules = [];

    if (useLab_imaging) {
        rules.push(
            {
                id: 1,
                label: 'توجه داشته باشید در این مرحله فقط ثبت درخواست انجام میشود.',
            },
            {
                id: 2,
                label: 'پس از پذیریش از جانب مرکز , از طریق پیامک به شما اطلاع رسانی خواهد شد.',
            },
        );
    } else {
        if (coordination === 'دارد') {
            rules.push(
                {
                    id: 1,
                    label: 'توجه داشته باشید که تاریخ و ساعت نوبت توسط منشی پس از ثبت درخواست نوبت مشخص و با پیامک برای شما ارسال خواهد شد.',
                },
                {
                    id: 2,
                    label: 'ثبت درخواست نوبت به منزله دریافت نوبت نمی باشد.',
                },
            );
        } else {
            rules.push(
                {
                    id: 1,
                    label: 'نوبت شما پس از پرداخت حق سامانه فعال می‌گردد.',
                },
                {
                    id: 2,
                    label: 'جهت مراجعه به مرکز درمانی رسید دریافتی نوبت را ارائه دهید.',
                },
            );
        }

        if (per_visit) {
            rules.push({
                active: true,
                id: 3,
                label: per_visit,
            });
        }
    }

    rules.push({
        active: false,
        id: 4,
        label: (
            <>
                <Link
                    className="text-blue-600 hover:underline"
                    href="/rules"
                    target="_blank"
                >
                    قوانین و مقررات
                </Link>{' '}
                سایت درمان شیرین را مطالعه و تایید می نمایم.
            </>
        ),
    });

    return rules;
};

export const login_Form_Alert = [
    { id: 1, label: 'اطلاعات خود را به درستی وارد نمایید ' },
    { id: 2, label: 'در صورت مشکل تیکت خود را بزاریید ' },
    { id: 3, label: 'قبل از ثبت نوبت اطلاعات خود را تکمیل نمایید ' },
    { id: 4, label: '..' },
];

// docid

export const dataTitle = [
    { id: 1, title: 'دریافت نوبت' },
    { id: 2, title: 'پیش نیازها', active: true },
    { id: 3, title: 'معرفی' },
    { id: 4, title: 'سوالات متداول' },
    { id: 5, title: 'نظرات' },
];

// terms

export const terms = {
    rule_one: [
        {
            id: 1,
            title: 'تعریف مشتری یا کاربر :',
            label: 'کاربر به شخصی گفته می‌شود که اطلاعات کاربری خود را در فرم ثبت ‌نام درمان شیرین درج نموده و با این اطلاعات، از خدمات درمان شیرین شامل ثبت نوبت پزشک ، آزمایشگاه ، دارویابی و خدمات غربالگری یا هرگونه خدمات دیگر بهرمند خواهد شد .',
        },
        {
            id: 2,
            title: 'تعریف خدمات دهندگان :',
            pt: true,
            label: 'اعم از افراد حقیقی یا حقوقی است که خدمات درمانی خود را در وب‌ سایت درمان شیرین عرضه کرده و به دریافت پروفایل مدیریت مطب و یا نوبت دهی آنلاین اقدام مینمایند می‌رساند. درمان شیرین اعتبار خدمات دهندگان را قبل از شروع همکاری بررسی کرده و مدارک موردنیاز را از ایشان دریافت می‌کند.نکته : ارائه دهندگان خدمات دارویی داروخانه های دارای مجوز از انجمن غذا و دارو میباشند و خدمات دارویی صرفا شامل اطلاع موجودی نسخه به بیمار و یا درخواست کننده خواهد بود و فروش اینترنتی دارو پیگرد قانون برای خدمات دهنده در پی خواهد داشت.',
        },
        {
            id: 3,
            title: 'قوانین کلی و ارتباط با مشتری :',
            pt: true,
            label: '',
            content: [
                'تعامل شما با درمان شیرین برای ارائه خدمات، مکاتبات و پاسخ‌گویی‌ها از طریق ارتباطات الکترونیکی صورت می‌پذیرد و به این ترتیب با استفاده از خدمات وب‌سایت، شما به‌صورت ضمنی توافق کرده‌اید که این پلتفرم به درخواست‌های شما از طریق ارتباطات الکترونیکی پاسخگو باشد.',
                'ادرس ایمیل درمان شیرین به آدرس darmanshirin@gmail.com میباشد و دریافت ایمیل از سایر آدرس ها معتبر نمیباشد.',
                'برای ارتباط با مشتریان، بهینه‌سازی محتوای وب‌سایت و تحقیقات بازاریابی، درمان شیرین ممکن است از اطلاعات شما استفاده کند و برای اطلاع‌رسانی رویدادها و اخبار، خدمات و سرویس‌های ویژه یا تخفیف‌ها، برای اعضای وب‌سایت ایمیل یا پیامک ارسال کند. این حق برای شما وجود دارد که در صورت عدم تمایل به دریافت این ایمیل‌ها و پیامک‌ها، عضویت دریافت خبرنامه و یا کمپین های درمان شیرین را در پروفایل خود لغو کنید و یا با واحد پشتیبانی تماس حاصل فرمایید لغو نکردن عضویت و یا عدم تماس با پشتیبانی ، به منزله موافقت ضمنی با دریافت ایمیل‌ها و پیام‌ها و سلب حق اعتراض تلقی می‌شود.',
            ],
        },
        {
            id: 3,
            pt: true,
            title: 'حریم خصوصی :',
            label: 'هویت شخصی کاربران ( کاربران آزاد و یا سازمانی ) نزد ما محرمانه است و اطلاعات شخصی کاربران از طریق پلتفرم درمان شیرین به هیچ شخص یا سازمان دیگری منتقل نمی‌شود. به جز در موارد حاکمیتی و دستورات قضایی.در پلتفرم درمان شیرین کاربر ملزم به ورود اطلاعات صحیح ( نظیر نام و نام خانوادگی ، کد ملی ، و اطلاعات بیمه ای بوده که در صورت بروز مشکل به علت قصور کاربر در ورود اطلاعات مسئولیت آن متوجه ایشان خواهد بود.نکته : از اطلاعات فردی و بیمه ای افراد جهت مدیریت پرونده های الکترونیکی و ثبت نسخ الکترونیک توسط پزشکان استفاده خواهد شد.پرونده پزشکی افراد حاوی اطلاعات پزشکی ایشان بوده که توسط پزشکان و یا به میل بیمار برای ایشان تدوین و ساخته خواهد شد نشر خصوصی و عمومی اطلاعات درمانی بیمار به عهده پزشک میباشد .سیستم ارجاع : در نوبت دهی به شیوه ارجاع بیمار پزشک اطلاعات درمانی بیمار را جهت اخذ و ثبت نوبت با نشر معرفی نامه الکترونیک به سایر پزشکان و یا مراکز درمانی ارجاع خواهد داد.پلتفرم درمان شیرین به عنوان تسهیل کننده خدمات دارویابی و نوبت دهی مراکز درمانی بوده و در قبال اقدامات و تشخیص و یا درمان خدمات دهندگان و پزشکان هیچ گونه مسئولیتی ندارد.- در صورت ثبت و رزرو نوبت پس از کنسلی هیچ وجهی به کاربر عودت داده نخواهد شد.',
        },
        {
            id: 4,
            pt: true,
            title: 'قوانین حفظ حریم خصوصی خدمات دهندگان :',
            label: 'خدمات دهندگان شامل پزشکان داروخانه ها و مراکز درمانی میباشند که درمان شیرین مکلف به حفظ اطلاعات شامل اطلاعات فردی ، حرفه ای و اطلاعات تماس ایشان میباشد.',
        },
        {
            id: 5,
            pt: true,
            title: 'قوانین مالی و تعرفه :',
            content: [
                'تمامی خدمات درمان شیرین دارای تعرفه بوده که تعرفه های آن به صورت شناور و به ازای هر خدمت متفاوت خواهد بود.=پرداخت از طریق درگاه متصل به سایت درمان شیرین صورت پذیرفته و هیچگونه عودت وجهی پس از پرداخت میسر نخواهد بود.',
                'تعرفه سایت از تعرفه ویزیت و حق الزحمه خدمات درمانی جدا بوده و سایت هیچگونه مسئولیتی در قبال پرداخت های مطب نخواهد داشت.',
                // notic
                'نکته : تعرفه ویزیت توسط پزشک و یا خدمات دهندگان درمانی معین میگردد.',
                'نکته : در صورت پرداخت الکترونیک ویزیت از طریق پنل پرداخت و عدم مراجعه بیمار عودت وجه بنا به قوانین مطب و مراکز درمانی خواهد بود و درمان شیرین در این موضوع هیچگونه مسئولیتی را نمیپذیرد.',
                'نکته: پرداخت تعرفه دارویابی پیش از اعلام موجودی و یا پذیرش دارو از جانب داروخانه ها اخذ گردیده و در صورت عدم پذیرش مبلغی عودت نخواهد شد.',
                'کاربر موظف است پس از اطلاع از داروخانه دارنده نسخه و پذیرش داروخانه جهت خرید به داروخانه مراجعه نماید.',
                'فرایند دارویابی متناسب با نسخه پزشک ، کد پیگیری نسخه انجام پذیرفته و پس از ثبت در موقعیت مکانی کاربر ، درخواست پس از مدت زمانی مشخص از یک منطقه به سایر نواحی نشر میابد.',
                'پس از ثبت نوبت برای پزشکان  و پرداخت تعرفه وبسایت  در صورت لغو نوبت  و یا عدم مراجعه بیمار  وجهی به بیمار عودت داده نخواهد شد .',
                'در صورت کنسلی نوبت از جانب مطب تعرفه وبسایت به کیف پول کاربر عودت داده خواهد شد.',
            ],
        },
        {
            id: 6,
            pt: true,
            title: 'قوانین دارویابی :',
            content: [
                'هنگام ثبت درخواست دارویی ارائه و بارگذاری کد پیگیری نسخه الکترونیک و یا تصویر نسخه الزامی میباشد .',
                'پس از پذیرش درخواست مراجعه بیمار جهت اخذ نسخه الزامی خواهد بود و دلیوری دارو تحت هر عنوان ممنوع میباشد .',
                'هرگونه ارسال دارو جنبه غیر قانونی داشته و مسئولیت آن به عهده درمان شیرین نمیباشد.',
                'بیمار مکلف است هنگام دریافت دارو تاریخ انقضا و اعتبار سنجی را به انجام برساند .',
            ],
        },
        {
            id: 7,
            pt: true,
            title: 'موارد بیشتر :',
            content: [
                'کلیه اطلاعات شخصی کاربران بصورت محرمانه نزد سامانه درمان شیرین باقی خواهد ماند.',
                'مسئولیت حفاظت ازاطلاعات کاربری شما به عهده خودتان است. هرگونه خسارت یا آسیب برخاسته از عدم حفاظت شما از مشخصات حساب کاربریتان متوجه شما بوده و سامانه درمان شیرین هیچ گونه مسئولیتی را بر عهده نمی‌گیرید.',
                'مسئولیت صحت تمامی اطلاعات وارد شده در حساب کاربری (از جمله نام و نام خانوادگی و سایر اطلاعات شخصی و حرفه ای) کاملا برعهده کاربر می باشد. در صورت مشاهده هرگونه تناقض اطلاعات وارد شده با اطلاعات واقعی کاربر، حساب کاربری تان حذف میگردد.',
                'حضور بیمار ده دقیقه قبل از وقت تعیین شده در مطب پزشک الزامی است به منظور ارائه کارت شناسایی و کد رهگیری نوبت خود به منشی مطب.',
                'میزان انتظار بیماران در مطب دکتر و یا کلینیک بسته به روند کاری پزشک و یا کلینیک مورد نظرمتفاوت است و درمان شیرین در این زمینه مسئول نمی باشد.',
                'حق ویزیت مندرج در وب سایت مطابق با تعرفه سازمان نظام پزشکی بوده و توسط پزشکان عضو سایت تعیین شده است.',
                'نسخه و داروهای درخواستی شما صرفا از داروخانه های دارای مجوز و طرف قرارداد این شرکت تامین و ارسال می گردد.',
                'تامین داروهای غیر مجاز و دارای ریسک امکان پذیر نمی باشد.',
                'نسخه بایستی مهور به مهر پزشک و دارای اصالت بیمه افراد طرف قرارداد باشد ( برای داروهای خاص ).',
                'زمان پاسخگویی جواب استعلام حداکثر 2 ساعت می باشد.',
                'در صورت داشتن پیش نیاز ویزیت برای پزشکان رعایت موارد ذکر شده الزامی می باشد.',
            ],
        },
    ],
};

// interface dashborads_doctor {
//     id: number;
//     title: string;
//     Subcategory?: {
//         label: string;
//         link?: string;
//     }[];
//     Icon?: IconType;
//     iconAroow?: boolean;
//     link?: string;
// }

// dahsborde

type newNameMenu = {
    id?: number;
    name: string;
    icon: IconType;
    link: string;
    border_b?: boolean;
};

export const newNameMenu_dashboarde: newNameMenu[] = [
    {
        id: 1,
        name: 'داشبورد',
        icon: FaHome,
        link: '/dashboard_doctor',
        border_b: true,
    },
    {
        id: 2,
        name: 'جراحی',
        icon: FaHeartCircleCheck,
        link: '/dashboard_doctor/surgery',
    },
    {
        id: 3,
        name: 'نوبت جدید',
        icon: PiUserCircleCheckLight,
        link: '/dashboard_doctor/new_appointment',
    },
    {
        id: 4,
        name: 'بیمار جدید',
        icon: MdPersonAddAlt1,
        link: '/dashboard_doctor/new_patient',
    },
    {
        id: 5,
        name: 'بیماران',
        icon: MdPersonSearch,
        link: '/dashboard_doctor/patients',
    },
    {
        id: 6,
        name: 'پنل کاربری',
        icon: FaChartGantt,
        link: '/dashboard_doctor/profile',
    },
];

export const titleBoxDah: newNameMenu[] = [
    {
        name: 'نوبت های امروز ',
        icon: TbBrandDaysCounter,
        link: '/dashboard_doctor/todays-turns',
    },
    { name: 'نوبت های امروز (مشاوره تلفنی)', icon: FaPhoneVolume, link: '' },
    { name: 'نوبت های امروز (خدمات)', icon: RiCustomerService2Line, link: '' },
    { name: 'نوبت های در انتظار تایید', icon: FaRegCheckCircle, link: '' },
    { name: 'ارجاع به من', icon: BsFillPersonCheckFill, link: '' },
    { name: 'بیماران', icon: MdPersonSearch, link: '' },
];

type TypedashsettingTab = {
    id: number;
    tab: string;
    link?: string;
    icon?: IconType;
    style?: string;
};

export const dash_settingTabs: TypedashsettingTab[] = [
    {
        id: 1,
        tab: 'منشی ها',
        link: '/dashboard_doctor/setting/secretary',
        icon: SlPeople,
    },
    {
        id: 2,
        tab: 'روزهای نوبت دهی مطب',
        icon: SlCalender,
        link: '/dashboard_doctor/setting/matab-appointments',
    },
    {
        id: 3,
        tab: 'روزهای نوبت دهی',
        icon: SlEvent,
        link: '/dashboard_doctor/setting/sepcial-time-das',
    },
    {
        id: 4,
        tab: 'برچسب های نوبت',
        icon: SlList,
        link: '/dashboard_doctor/setting/turn-labels',
    },
    {
        id: 5,
        tab: 'مطب دوم',
        icon: SlOrganization,
        link: '/dashboard_doctor/setting/second-office',
    },
    {
        id: 6,
        tab: 'خدمات سرپایی مطب',
        icon: SlUserFollowing,
        link: '/dashboard_doctor/setting/outpatient-services',
    },
    {
        id: 7,
        tab: 'موارد جراحی',
        icon: SlEqualizer,
        link: '/dashboard_doctor/setting/surgical',
    },
    {
        id: 8,
        tab: 'بیمارستان',
        icon: LiaHospitalSolid,
        link: '/dashboard_doctor/setting/hospital',
    },
    { id: 9, tab: 'دریافت لیست اکسل بیماران', icon: RiFileExcel2Line },
    { id: 10, tab: 'system log', icon: TbHeartRateMonitor },
];

export const allowedFormats = [
    'application/pdf',
    'application/zip',
    'image/png',
    'image/jpeg',
    'image/jpg',
    'image/fif',
    'application/x-rar-compressed',
];
